import "./Login.css";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const apiPrefix = process.env.REACT_APP_API_PREFIX;
const appleAuthRedirectUrl = process.env.REACT_APP_APPLE_AUTH_REDIRECT_URL;

const isApple = /(Mac|iPhone|iPod|iPad)/i.test(navigator.userAgent);

const Login = ({ setToken, setIsNewUser }) => {
  const [appleLoginIsLoading, setAppleLoginIsLoading] = useState(false);
  const [showAppleSignIn, setShowAppleSignIn] = useState(isApple);

  // const handleDummySignIn = async () => {
  //   try {
  //     const res = await fetch(`${apiPrefix}/login`, {
  //       method: "POST",
  //       headers: new Headers({
  //         "ngrok-skip-browser-warning": true,
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //       }),
  //       body: JSON.stringify({ type: "dummy" }),
  //     });
  //     const json = await res.json();
  //     localStorage.setItem("jwt-token", json.token);
  //     setToken(json.token);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  useEffect(() => {
    window.initializeGoogleAuth = () => {
      window.google.accounts.id.initialize({
        client_id:
          "279456677700-33qj8b4ct95cav7kqthit4cjmr468vs5.apps.googleusercontent.com",
        callback: handleGoogleCredentialResponse,
        ux_mode: "popup",
      });
    };
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    script.onload = () => {
      window.initializeGoogleAuth();
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  });

  const createFakeGoogleWrapper = () => {
    const googleLoginWrapper = document.createElement("div");
    googleLoginWrapper.style.display = "none";
    googleLoginWrapper.classList.add("custom-google-button");
    document.body.appendChild(googleLoginWrapper);
    window.google.accounts.id.renderButton(googleLoginWrapper, {
      type: "icon",
      width: "200",
    });

    const googleLoginWrapperButton =
      googleLoginWrapper.querySelector("div[role=button]");

    return {
      click: () => {
        googleLoginWrapperButton.click();
      },
    };
  };

  const handleGoogleCredentialResponse = async (response) => {
    try {
      const res = await fetch(`${apiPrefix}/login`, {
        method: "POST",
        headers: new Headers({
          "ngrok-skip-browser-warning": true,
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({ type: "google", code: response.credential }),
      });
      if (res.ok) {
        const json = await res.json();
        localStorage.setItem("jwt-token", json.token);
        setToken(json.token);
        if (res.headers.has("X-New-User")) {
          setIsNewUser(true);
        }
      } else {
        toast.error("Die Anmeldung mit Google hat leider nicht funktioniert.");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleGoogleSignIn = () => {
    window.google.accounts.id.prompt((notification) => {
      if (notification.isNotDisplayed()) {
        const googleButtonWrapper = createFakeGoogleWrapper();
        googleButtonWrapper.click();
      }
    });
  };

  useEffect(() => {
    window.AppleID.auth.init({
      clientId: "app.buono",
      scope: "",
      redirectURI: appleAuthRedirectUrl,
      state: "some-state",
      nonce: "some-nonce",
      usePopup: true,
    });
  }, []);

  const handleAppleSignIn = async () => {
    try {
      const data = await window.AppleID.auth.signIn();
      const res = await fetch(`${apiPrefix}/login`, {
        method: "POST",
        headers: new Headers({
          "ngrok-skip-browser-warning": true,
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({ type: "apple", code: data.authorization.code }),
      });
      if (res.ok) {
        const json = await res.json();
        localStorage.setItem("jwt-token", json.token);
        setToken(json.token);
        if (res.headers.has("X-New-User")) {
          setIsNewUser(true);
        }
      } else {
        toast.error("Die Anmeldung mit Apple hat leider nicht funktioniert.");
      }
    } catch (err) {
      console.log(err);
    }
    setAppleLoginIsLoading(false);
  };

  return (
    <Container className="text-center p-5">
      <Row className="mb-5">
        <Col>
          <img
            alt=""
            src="buono-logo.svg"
            width="60"
            height="60"
            className="filter-gray"
          />
        </Col>
      </Row>
      <Row className="m-2">
        <Col>
          <h1>Hallo!</h1>
        </Col>
      </Row>
      <Row>
        <Col>
          <h4>
            Bitte melde dich an,
            <br />
            um loszulegen.
          </h4>
        </Col>
      </Row>

      {showAppleSignIn ? (
        <div>
          <Row>
            <Col>
              <Button
                className="mt-4"
                variant="dark"
                size="lg"
                disabled={appleLoginIsLoading}
                onClick={() => {
                  if (appleLoginIsLoading === false) {
                    setAppleLoginIsLoading((prevValue) => true);
                    setTimeout(function () {
                      handleAppleSignIn();
                    }, 100);
                  }
                }}
              >
                <img
                  className="mb-2 me-1"
                  src="apple-logo.svg"
                  width="20"
                  alt="Apple"
                />
                {appleLoginIsLoading ? "Laden..." : "Mit Apple anmelden"}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                variant="link"
                className="mt-4 text-muted"
                style={{ fontSize: "12px" }}
                onClick={() => setShowAppleSignIn(false)}
              >
                Ich habe kein Apple Konto
              </Button>
            </Col>
          </Row>
        </div>
      ) : (
        <div>
          <Row>
            <Col>
              <Button
                className="mt-4"
                variant="dark"
                size="lg"
                onClick={() => handleGoogleSignIn()}
              >
                <img
                  className="mb-1 me-2"
                  src="google-logo.svg"
                  width="20"
                  alt="Google"
                />
                Über Google anmelden
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                variant="link"
                className="mt-4 text-muted"
                style={{ fontSize: "12px" }}
                onClick={() => setShowAppleSignIn(true)}
              >
                Ich habe kein Google Konto
              </Button>
            </Col>
          </Row>
        </div>
      )}
      <Row>
        <Col>
          <Button
            variant="link"
            className="mt-0 text-muted"
            style={{ fontSize: "12px" }}
            href="/policy"
          >
            AGB, Datenschutz, Impressum
          </Button>
        </Col>
      </Row>

      {/* <Row>
        <Col>
          <Button size="lg" className="m-2" onClick={() => handleDummySignIn()}>
            Entwickler Anmeldung
          </Button>
        </Col>
      </Row> */}
    </Container>
  );
};

export default Login;
